import React from "react";
import axios from "../../../containers/api";
import { Link, NavLink } from "react-router-dom";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import { Table } from "../../../components/table/Table";
import Config from "../../../constants/config";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Collapse,
  FormGroup,
  Label,
  Nav,
  NavItem,
  Row,
  Col,
  TabContent,
  TabPane,
  ModalBody,
  Modal,
  ModalHeader,
  Input,
  CustomInput,
  ModalFooter,
  CardTitle,
} from "reactstrap";

import {
  getkalas,
  showCatchError,
  convertDate,
  toCurrency,
  toEnglishNumbers,
} from "../../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import "./cargos.css";

class Cargos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "1",
      optionsMenu: null,
      collapse: true,
      fromDate: utils("fa").getToday(),
      toDate: utils("fa").getToday(),
      Cargos: [],

      customers: [],
      kalas: [],
      senders: [],
      receivers: [],

      selectedkalas: [],
      CargosSearchResult: [],
      CargoId: null,
      mode: 1,
      TransportationCompanyList: [],
      TransportationCompany: null,
      CargoStatus: [
        { value: 0, text: "فعال" },
        { value: 1, text: "غیرفعال" },
        { value: 2, text: "همه" },
      ],
      selectedCargoStatus: { value: 2, text: "همه" },
      FinishCargoModal: false,
      IsLoadHall: false,
      FinishDesc: "",
      DetailModal: false,
      selectedCargo: null,
    };
  }

  componentDidMount() {
    if (this.state.kalas.length === 0) {
      try {
        this.getkalasApi().then((r) => console.log(r));
      } catch (err) {
        console.log(err);
      }
    }

    if (
      this.props.memberType.role === "ProductOwnerAdmin" ||
      this.props.memberType.role === "Driver" ||
      this.props.memberType.role === "AdminSupport" ||
      this.props.memberType.role === "Admin" ||
      this.props.memberType.role === "Organization" ||
      this.props.memberType.role === "DriversAssociation" ||
      this.props.memberType.role === "AssociationTransportCompanies"
    ) {
      this.GetAllTransportationCompany();
      this.GetAllCustomer();
    } else this.GetCustomerByTransportationCompanyId();

    this.SearchCargo();
    window.scrollTo(0, 0);
  }

  GetCustomerByTransportationCompanyId = () => {
    axios
      .get("/api/v1/Customer/GetCustomerByTransportationCompanyId")
      .then((res) => {
        this.props.hideSpinner();
        this.setState({ customers: res.data.data });
      })
      .catch((error) => {
        this.props.hideSpinner();
        console.log(error.response);
        this.props.showAlert(showCatchError(error), "error");
      });
  };
  GetAllCustomer = () => {
    axios
      .get("/api/v1/Customer/GetAllCustomer")
      .then((res) => {
        this.props.hideSpinner();
        this.setState({ customers: res.data.data });
      })
      .catch((error) => {
        this.props.hideSpinner();
        console.log(error.response);
        this.props.showAlert(showCatchError(error), "error");
      });
  };

  GetAllTransportationCompany = () => {
    let api = "";
    if (
      this.props.memberType.role === "Organization" ||
      this.props.memberType.role === "DriversAssociation" ||
      this.props.memberType.role === "AssociationTransportCompanies"
    )
      api = "TransportationCompanyUser/GetByUserId";
    else api = "TransportationCompany/GetAll";
    axios
      .get("/api/v1/" + api)
      .then((res) => {
        this.props.hideSpinner();
        this.setState({ TransportationCompanyList: res.data.data });
      })
      .catch((error) => {
        this.props.hideSpinner();
        console.log(error.response);
        this.props.showAlert(showCatchError(error), "error");
      });
  };

  async getkalasApi() {
    try {
      await getkalas().then((res) => this.setState({ kalas: res.data }));
    } catch (err) {
      this.props.showAlert(showCatchError(err), "error");
    }
  }

  SearchCargo = () => {
    let searchModel = {
      FromDate: convertDate(this.state.fromDate),
      ToDate: convertDate(this.state.toDate),
      ReceiverCustomerId: [],
      SenderCustomerId: [],
      KalaId: [],
      CargoStatus: toEnglishNumbers(this.state.selectedCargoStatus.value),
      TransportationCompanyId: null,
    };
    if (
      this.props.memberType.role === "AdminSupport" ||
      this.props.memberType.role === "Admin" ||
      this.props.memberType.role === "Organization" ||
      this.props.memberType.role === "DriversAssociation" ||
      this.props.memberType.role === "AssociationTransportCompanies"
    )
      searchModel.TransportationCompanyId =
        this.state.TransportationCompany !== null &&
        this.state.TransportationCompany !== undefined
          ? this.state.TransportationCompany.transportationCompanyId
          : null;
    if (this.state.receivers.length !== 0) {
      this.state.receivers.map((receiver) =>
        searchModel.ReceiverCustomerId.push(receiver.id),
      );
    }
    if (this.state.senders.length !== 0) {
      this.state.senders.map((sender) =>
        searchModel.SenderCustomerId.push(sender.id),
      );
    }

    if (this.state.selectedkalas.length !== 0) {
      this.state.selectedkalas.map((selectedkala) =>
        searchModel.KalaId.push(selectedkala.id),
      );
    }

    this.props.showSpinner();
    axios
      .post("/api/v1/Cargo/SearchCargo", searchModel)
      .then((res) => {
        this.props.hideSpinner();
        console.log(res.data.data);
        this.setState({
          CargosSearchResult: res.data.data,
          searchFilters: false,
        });
        if (this.state.CargosSearchResult.length === 0) {
          this.props.showAlert("موردی یافت نشد", "warning");
        } else {
          this.props.showAlert(
            this.state.CargosSearchResult.length.toString() + " مورد یافت شد",
            "success",
          );
        }
      })
      .catch((error) => {
        this.props.hideSpinner();
        console.log(error.response);
        this.props.showAlert(showCatchError(error), "error");
      });
  };

  clearSearch = () => {
    this.setState({
      receivers: [],
      senders: [],
      selectedkalas: [],
      selectedCargoStatus: { value: 2, text: "همه" },
      fromDate: utils("fa").getToday(),
      toDate: utils("fa").getToday(),
    });
    if (
      this.props.memberType.role === "AdminSupport" ||
      this.props.memberType.role === "Admin" ||
      this.props.memberType.role === "Organization" ||
      this.props.memberType.role === "DriversAssociation" ||
      this.props.memberType.role === "AssociationTransportCompanies"
    ) {
      this.setState({
        TransportationCompany: null,
      });
    }
  };

  Redirect = (AccordNumber, CargoId) => {
    const location = {
      pathname: "/Cargos/Detail/" + CargoId + "/" + AccordNumber,
    };
    this.props.history.push(location);
  };

  selectHandleChange = (event, value, name) => {
    this.setState({ [name]: value });
  };

  OptionsMenuClick = (event, id) => {
    this.setState({ [id]: event.currentTarget, optionsMenu: id });
  };
  OptionsMenuClose = (id) => {
    this.setState({ [id]: null, optionsMenu: null });
  };
  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };
  FinishCargo = () => {
    this.props.closeSweetAlert();

    let cancelPriority =
      this.props.memberType.role === "Admin"
        ? this.state.IsCancelPriority
        : null;
    if (
      this.state.FinishDesc === null ||
      this.state.FinishDesc === undefined ||
      this.state.FinishDesc === "" ||
      this.state.FinishDesc === ""
    ) {
      this.props.showAlert("وارد كردن علت اتمام بار الزامی میباشد!", "error");
      return;
    }
    const model = {
      Id: this.state.CargoId,
      IsCancelPriority: cancelPriority,
      Desc: toEnglishNumbers(this.state.FinishDesc),
    };
    this.props.showSpinner();
    axios
      .post("/api/v1/Cargo/FinishCargo", model)
      .then((res) => {
        this.props.hideSpinner();
        if (res.data.data.code == 1) {
          this.props.showAlert(res.data.data.message, "success");
          this.SearchCargo();
        } else this.props.showAlert(res.data.data.message, "error");
      })
      .catch((error) => {
        console.log(error.response);
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
      });
  };
  ActiveCargo = (id) => {
    this.props.closeSweetAlert();
    this.props.showSpinner();
    axios
      .post("api/v1/Cargo/ActiveCargo?cargoId=" + id, null)
      .then(() => {
        this.props.showAlert("بار با موفقیت تایید شد", "success");
        this.SearchCargo();
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };
  closeModal = (modalName) => {
    this.setState({ [modalName]: false });
  };
  Reserve = (cargo) => {
    let Id = parseInt(this.props.memberType.clientId);
    const model = {
      CargoId: cargo.id,
      ReserveType: true,
      DriverId: Id,
      IsWeb: true,
    };
    this.props.closeSweetAlert();
    this.props.showSpinner();

    axios
      .post("api/v1/DriverReserve/AddDriverReserve", model)
      .then((res) => {
        console.log(res.data.data);

        if (res.data.statusCode === 200) {
          this.props.hideSpinner();
          this.props.showAlert(res.data.data, "success");
          this.SearchCargo();
        } else {
          this.props.showAlert(res.data.errors[0], "error");
          this.props.hideSpinner();
        }
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };

  // یک منبع واحد برای وضعیت بار: هم در جدول و هم در مودال جزئیات استفاده می‌شود
  getCargoStatusInfo = (cargoStatus) => {
    switch (cargoStatus) {
      case -1:
        return { text: "در انتظار تایید شرکت", color: "success" };
      case 0:
        return { text: "در حال ارسال", color: "success" };
      case 1:
        return { text: "اتمام بار", color: "warning" };
      case 2:
        return { text: "بارگذاری حواله", color: "warning" };
      case 3:
        return { text: "بارگذاری بارنامه", color: "warning" };
      case 4:
        return { text: "تغییر کرایه در انتظار تایید", color: "warning" };
      default:
        return { text: "-", color: "secondary" };
    }
  };

  openDetailModal = (Cargo) => {
    // بستن منوی "بیشتر" و باز کردن مودال جزئیات
    this.setState({
      [Cargo.id]: null,
      optionsMenu: null,
      DetailModal: true,
      selectedCargo: Cargo,
    });
  };

  render() {
    const statusInfo = this.state.selectedCargo
      ? this.getCargoStatusInfo(this.state.selectedCargo.cargoStatus)
      : null;

    return (
      <>
        <Row>
          <Colxx xxs="12">
            <div className="cargo-page-header">
              <div className="cargo-page-icon">
                <i className="fa fa-truck" aria-hidden="true" />
              </div>
              <h3>لیست بارهای اعلام شده</h3>
            </div>
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <Row>
          <Colxx xxs="12">
            <Card className="cargo-search-card">
              <CardBody className="cargo-search-body">
                <Row>
                  <Colxx sm="12">
                    <CardBody className="cargo-search-body">
                      <CardTitle>
                        <i className="fa fa-search" aria-hidden="true" />
                        جستجو
                      </CardTitle>
                      <div className="cargo-filters-box d-flex flex-column">
                        <div className="cargo-filters-row">
                          <FormGroup className="w-md-25 w-100 px-1">
                            <Label>از تاریخ</Label>
                            <DatePicker
                              value={this.state.fromDate}
                              onChange={(newDate) =>
                                this.setState({ fromDate: newDate })
                              }
                              inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                              shouldHighlightWeekends
                              inputClassName="form-control"
                              locale="fa"
                              calendarClassName="calendar"
                              colorPrimary={Config.color}
                              calendarPopperPosition={"bottom"}
                            />
                          </FormGroup>

                          <FormGroup className="w-md-25 w-100 px-1">
                            <Label>تا تاریخ</Label>
                            <DatePicker
                              value={this.state.toDate}
                              onChange={(newDate) =>
                                this.setState({ toDate: newDate })
                              }
                              inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                              shouldHighlightWeekends
                              inputClassName="form-control"
                              locale="fa"
                              calendarClassName="calendar"
                              colorPrimary={Config.color}
                              calendarPopperPosition={"bottom"}
                            />
                          </FormGroup>
                          <FormGroup className="w-md-25 w-100 px-1">
                            <Label>وضعیت</Label>
                            <Autocomplete
                              disableClearable
                              clearText={"حذف"}
                              closeText={"بستن"}
                              noOptionsText={"در حال دریافت اطلاعات.."}
                              openText={"باز کردن"}
                              className="react-select__control"
                              id="selectedCargoStatus"
                              options={this.state.CargoStatus}
                              getOptionLabel={(option) => option.text}
                              value={this.state.selectedCargoStatus}
                              onChange={(e, v) =>
                                this.selectHandleChange(
                                  e,
                                  v,
                                  "selectedCargoStatus",
                                )
                              }
                              renderInput={(params) => (
                                <TextField {...params} variant="standard" />
                              )}
                            />
                          </FormGroup>
                        </div>
                        {(this.props.memberType.role === "AdminSupport" ||
                          this.props.memberType.role === "Admin" ||
                          this.props.memberType.role === "Organization" ||
                          this.props.memberType.role === "DriversAssociation" ||
                          this.props.memberType.role ===
                            "AssociationTransportCompanies") && (
                          <div className="cargo-filters-row">
                            <FormGroup className="w-md-30 w-100 px-1">
                              <Label>شركت های حمل و نقل</Label>
                              <Autocomplete
                                clearText={"حذف"}
                                closeText={"بستن"}
                                noOptionsText={"در حال دریافت اطلاعات.."}
                                openText={"باز کردن"}
                                className="react-select__control"
                                id="TransportationCompany"
                                options={this.state.TransportationCompanyList}
                                getOptionLabel={(option) =>
                                  option.transportationCompanyName
                                }
                                value={this.state.TransportationCompany}
                                onChange={(e, v) =>
                                  this.selectHandleChange(
                                    e,
                                    v,
                                    "TransportationCompany",
                                  )
                                }
                                renderInput={(params) => (
                                  <TextField {...params} variant="standard" />
                                )}
                              />
                            </FormGroup>
                          </div>
                        )}
                        <div className="cargo-search-actions">
                          <Button color="primary" onClick={this.SearchCargo}>
                            <i className="fa fa-search" aria-hidden="true" />
                            جستجو
                          </Button>
                          <Button
                            color="secondary"
                            outline
                            onClick={this.clearSearch}
                          >
                            <i className="fa fa-eraser" aria-hidden="true" />
                            پاک کردن
                          </Button>
                        </div>
                      </div>
                      <Table
                        tableHeaders={[
                          "شناسه بار",
                          "وضعیت بار",
                          "مبدا",
                          "مقصد",
                          "وزن بار",
                          "تعداد",
                          "کل کرایه",
                          "صافی راننده",
                          "کمسیون شرکت",
                          "سهم سازمان",
                          "بیمه بار",
                          "نوع محموله",
                          "نوع ماشین",
                          "تاریخ",
                          "ساعت",
                          "عملیات",
                        ]}
                        tableRow={this.state.CargosSearchResult}
                        tableData={[
                          (Cargo) => {
                            return Cargo.id;
                          },
                          (Cargo) => {
                            const info = this.getCargoStatusInfo(
                              Cargo.cargoStatus,
                            );
                            return (
                              <Badge color={"outline-" + info.color} pill>
                                {info.text}
                              </Badge>
                            );
                          },
                          (Cargo) => {
                            return Cargo.cargoSource;
                          },
                          (Cargo) => {
                            return Cargo.cargoDestination;
                          },
                          (Cargo) => {
                            return Cargo.kalaWeight !== null &&
                              Cargo.kalaWeight !== ""
                              ? toCurrency(Cargo.kalaWeight)
                              : null;
                          },
                          (Cargo) => {
                            return Cargo.freighterNumber;
                          },
                          (Cargo) => {
                            return Cargo.totalPrice !== null &&
                              Cargo.totalPrice !== ""
                              ? toCurrency(Cargo.totalPrice)
                              : null;
                          },
                          (Cargo) => {
                            return Cargo.cargoRent !== null &&
                              Cargo.cargoRent !== ""
                              ? toCurrency(Cargo.cargoRent)
                              : null;
                          },
                          (Cargo) => {
                            return Cargo.companyPrice !== null &&
                              Cargo.companyPrice !== ""
                              ? toCurrency(Cargo.companyPrice)
                              : null;
                          },
                          (Cargo) => {
                            return Cargo.sazmanPrice !== null &&
                              Cargo.sazmanPrice !== ""
                              ? toCurrency(Cargo.sazmanPrice)
                              : null;
                          },
                          (Cargo) => {
                            return Cargo.bimePrice !== null &&
                              Cargo.bimePrice !== ""
                              ? toCurrency(Cargo.bimePrice)
                              : null;
                          },
                          (Cargo) => {
                            return Cargo.kalaDesc;
                          },
                          (Cargo) => {
                            return Cargo.loaderTypeNames;
                          },
                          (Cargo) => {
                            return Cargo.cargoDate;
                          },
                          (Cargo) => {
                            return Cargo.cargoTime;
                          },

                          (Cargo) => {
                            return (
                              <>
                                <Button
                                  outline
                                  color="primary"
                                  size="sm"
                                  className="cargo-more-btn"
                                  aria-controls={"menu-" + Cargo.id}
                                  aria-haspopup="true"
                                  aria-expanded={
                                    this.state.optionsMenu === Cargo.id
                                      ? "true"
                                      : undefined
                                  }
                                  onClick={(event) =>
                                    this.OptionsMenuClick(event, Cargo.id)
                                  }
                                >
                                  بیشتر{" "}
                                  <i
                                    className="fa fa-ellipsis-v mr-1"
                                    aria-hidden="true"
                                  />
                                </Button>
                                <Menu
                                  id={"menu-" + Cargo.id}
                                  MenuListProps={{
                                    "aria-labelledby": "fade-button",
                                  }}
                                  anchorEl={this.state[Cargo.id]}
                                  open={this.state.optionsMenu === Cargo.id}
                                  onClose={() =>
                                    this.OptionsMenuClose(Cargo.id)
                                  }
                                >
                                  <MenuItem
                                    onClick={() => this.openDetailModal(Cargo)}
                                  >
                                    جزئیات
                                  </MenuItem>
                                  {this.props.memberType.role !== "Driver" && (
                                    <MenuItem
                                      component={Link}
                                      to={`/EditCargo/${Cargo.id}`}
                                    >
                                      ویرایش
                                    </MenuItem>
                                  )}
                                  {this.props.memberType.role ===
                                    "TransportationCompanyAdmin" && (
                                    <MenuItem
                                      onClick={() =>
                                        this.props.showSweetAlert(
                                          "آیا این بار تایید شود؟",
                                          "",
                                          "success",
                                          () => this.ActiveCargo(Cargo.id),
                                        )
                                      }
                                    >
                                      تایید اعلام بار
                                    </MenuItem>
                                  )}
                                  {this.props.memberType.role !== "Driver" && (
                                    <MenuItem
                                      onClick={() =>
                                        this.setState({
                                          FinishCargoModal: true,
                                          FinishDesc: "",
                                          IsCancelPriority: false,
                                          CargoId: Cargo.id,
                                          IsLoadHall: Cargo.isLoadHall,
                                        })
                                      }
                                    >
                                      اعلام اتمام بار
                                    </MenuItem>
                                  )}
                                  {Cargo.cargoStatus === 0 &&
                                    this.props.memberType.role === "Driver" && (
                                      <MenuItem
                                        onClick={() =>
                                          this.props.showSweetAlert(
                                            "آیا این بار رزرو شود؟",
                                            "",
                                            "success",
                                            () => this.Reserve(Cargo),
                                          )
                                        }
                                      >
                                        رزرو بار
                                      </MenuItem>
                                    )}
                                </Menu>
                              </>
                            );
                          },
                        ]}
                      />
                    </CardBody>
                  </Colxx>
                </Row>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
        <Modal
          isOpen={this.state.FinishCargoModal}
          toggle={() => this.closeModal("FinishCargoModal")}
          size="xlg"
        >
          <ModalHeader toggle={() => this.closeModal("FinishCargoModal")}>
            اتمام بار
          </ModalHeader>
          <ModalBody>
            <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
              <FormGroup className="w-md-50 w-100 mx-1">
                <Label>علت اتمام بار</Label>
                <Input
                  value={this.state.FinishDesc}
                  onChange={(e) =>
                    this.setState({ FinishDesc: e.target.value })
                  }
                />
              </FormGroup>
            </div>
            {this.props.memberType.role === "Admin" &&
              this.state.IsLoadHall === true && (
                <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                  <FormGroup className="w-md-50 w-100 mx-1">
                    <CustomInput
                      checked={this.state.IsCancelPriority === true}
                      onClick={() =>
                        this.setState({
                          IsCancelPriority: !this.state.IsCancelPriority,
                        })
                      }
                      type="checkbox"
                      label="كنسل كردن اولويت‌های فعال"
                      id="IsCancelPriority"
                    />
                  </FormGroup>
                </div>
              )}

            <div className="d-flex mb-2 mt-4 justify-content-center align-items-center">
              <Button
                color="primary"
                className="btn-lg mx-2"
                onClick={() =>
                  this.props.showSweetAlert(
                    "اتمام بار انجام شود؟",
                    "",
                    "success",
                    this.FinishCargo,
                  )
                }
              >
                اتمام بار
              </Button>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => this.closeModal("FinishCargoModal")}
            >
              انصراف
            </Button>
          </ModalFooter>
        </Modal>

        {/* مودال جزئیات بار */}
        <Modal
          isOpen={this.state.DetailModal}
          toggle={() => this.closeModal("DetailModal")}
          size="lg"
          centered
          className="cargo-detail-modal"
        >
          <ModalHeader toggle={() => this.closeModal("DetailModal")}>
            {this.state.selectedCargo
              ? `جزئیات بار #${this.state.selectedCargo.id}`
              : "جزئیات بار"}
          </ModalHeader>
          <ModalBody>
            {this.state.selectedCargo && (
              <>
                {/* بخش برجسته: وضعیت و کل کرایه */}
                <Row className="mb-4">
                  <Col xs="12" md="6" className="mb-3 mb-md-0">
                    <div
                      className="d-flex flex-column align-items-center justify-content-center rounded p-3 h-100"
                      style={{
                        background:
                          statusInfo && statusInfo.color === "warning"
                            ? "linear-gradient(135deg,#fff8e1,#ffecb3)"
                            : "linear-gradient(135deg,#e8f5e9,#c8e6c9)",
                        border: "1px solid rgba(0,0,0,0.06)",
                      }}
                    >
                      <span
                        className="text-muted mb-2"
                        style={{ fontSize: 14 }}
                      >
                        وضعیت بار
                      </span>
                      <Badge
                        color={statusInfo ? statusInfo.color : "secondary"}
                        pill
                        style={{
                          fontSize: 18,
                          padding: "10px 22px",
                          fontWeight: "bold",
                        }}
                      >
                        {statusInfo ? statusInfo.text : "-"}
                      </Badge>
                    </div>
                  </Col>
                  <Col xs="12" md="6">
                    <div
                      className="d-flex flex-column align-items-center justify-content-center rounded p-3 h-100"
                      style={{
                        background: "linear-gradient(135deg,#e3f2fd,#bbdefb)",
                        border: "1px solid rgba(0,0,0,0.06)",
                      }}
                    >
                      <span
                        className="text-muted mb-2"
                        style={{ fontSize: 14 }}
                      >
                        کل کرایه
                      </span>
                      <span
                        style={{
                          fontSize: 28,
                          fontWeight: 800,
                          color: "#0d47a1",
                        }}
                      >
                        {this.state.selectedCargo.totalPrice !== null &&
                        this.state.selectedCargo.totalPrice !== ""
                          ? toCurrency(this.state.selectedCargo.totalPrice) +
                            " ریال"
                          : "-"}
                      </span>
                    </div>
                  </Col>
                </Row>

                <Separator className="mb-3" />

                {/* سایر اطلاعات بار */}
                <Row>
                  <Col xs="6" md="4" className="mb-3">
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      مبدا
                    </div>
                    <div className="font-weight-bold">
                      {this.state.selectedCargo.cargoSource || "-"}
                    </div>
                  </Col>
                  <Col xs="6" md="4" className="mb-3">
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      مقصد
                    </div>
                    <div className="font-weight-bold">
                      {this.state.selectedCargo.cargoDestination || "-"}
                    </div>
                  </Col>
                  <Col xs="6" md="4" className="mb-3">
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      وزن بار
                    </div>
                    <div className="font-weight-bold">
                      {this.state.selectedCargo.kalaWeight !== null &&
                      this.state.selectedCargo.kalaWeight !== ""
                        ? toCurrency(this.state.selectedCargo.kalaWeight)
                        : "-"}
                    </div>
                  </Col>
                  <Col xs="6" md="4" className="mb-3">
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      تعداد
                    </div>
                    <div className="font-weight-bold">
                      {this.state.selectedCargo.freighterNumber || "-"}
                    </div>
                  </Col>
                  <Col xs="6" md="4" className="mb-3">
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      صافی راننده
                    </div>
                    <div className="font-weight-bold">
                      {this.state.selectedCargo.cargoRent !== null &&
                      this.state.selectedCargo.cargoRent !== ""
                        ? toCurrency(this.state.selectedCargo.cargoRent)
                        : "-"}
                    </div>
                  </Col>
                  <Col xs="6" md="4" className="mb-3">
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      کمسیون شرکت
                    </div>
                    <div className="font-weight-bold">
                      {this.state.selectedCargo.companyPrice !== null &&
                      this.state.selectedCargo.companyPrice !== ""
                        ? toCurrency(this.state.selectedCargo.companyPrice)
                        : "-"}
                    </div>
                  </Col>
                  <Col xs="6" md="4" className="mb-3">
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      سهم سازمان
                    </div>
                    <div className="font-weight-bold">
                      {this.state.selectedCargo.sazmanPrice !== null &&
                      this.state.selectedCargo.sazmanPrice !== ""
                        ? toCurrency(this.state.selectedCargo.sazmanPrice)
                        : "-"}
                    </div>
                  </Col>
                  <Col xs="6" md="4" className="mb-3">
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      بیمه بار
                    </div>
                    <div className="font-weight-bold">
                      {this.state.selectedCargo.bimePrice !== null &&
                      this.state.selectedCargo.bimePrice !== ""
                        ? toCurrency(this.state.selectedCargo.bimePrice)
                        : "-"}
                    </div>
                  </Col>
                  <Col xs="6" md="4" className="mb-3">
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      نوع محموله
                    </div>
                    <div className="font-weight-bold">
                      {this.state.selectedCargo.kalaDesc || "-"}
                    </div>
                  </Col>
                  <Col xs="6" md="4" className="mb-3">
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      نوع ماشین
                    </div>
                    <div className="font-weight-bold">
                      {this.state.selectedCargo.loaderTypeNames || "-"}
                    </div>
                  </Col>
                  <Col xs="6" md="4" className="mb-3">
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      تاریخ
                    </div>
                    <div className="font-weight-bold">
                      {this.state.selectedCargo.cargoDate || "-"}
                    </div>
                  </Col>
                  <Col xs="6" md="4" className="mb-3">
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      ساعت
                    </div>
                    <div className="font-weight-bold">
                      {this.state.selectedCargo.cargoTime || "-"}
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => this.closeModal("DetailModal")}
            >
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default Cargos;
